import { render, staticRenderFns } from "./carDispatchForm.vue?vue&type=template&id=0a2d8350&scoped=true"
import script from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./carDispatchForm.vue?vue&type=style&index=0&id=0a2d8350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d8350",
  null
  
)

export default component.exports